import ClientPortalDashboard from './ClientPortalDashboard';

export default ClientPortalDashboard;
